import React, { useEffect } from 'react';

import ScriptLoader from '../../page/components/script-loader';

export default ({
    name,
    badge = 'bottomleft',
    siteKey = '6LeNXDEUAAAAAKf-2O-Ltzp6jsaVOsod92WeRf1d',
    callback = () => {},
    onLoad = () => {},
    size = 'invisible',
}) => {
    const callbackName = `recaptchCB${name}`;
    const onLoadCallbackName = `recaptchOnLoad${name}`;
    const id = `recaptcha${name}`;
    useEffect(() => {
        if (window) {
            window[callbackName] = token => callback(token);
            window[onLoadCallbackName] = () => onLoad();
            window.grecaptcha &&
                window.grecaptcha.render(document.getElementById(id), {
                    sitekey: siteKey,
                    badge: badge,
                    callback: callbackName,
                    size: size,
                });
        }
        //remove global function on unmount
        return function cleanup() {
            delete window[callbackName];
            delete window[onLoadCallbackName];
        };
    }, [name]);
    return (
        <>
            <ScriptLoader
                name="recaptcha"
                url={`https://www.google.com/recaptcha/api.js?onload=${onLoadCallbackName}&render=${siteKey}`}
            />
            <div
                id={id}
                className="g-recaptcha"
                data-badge={badge}
                data-sitekey={siteKey}
                data-callback={callbackName}
                data-size={size}
            ></div>
        </>
    );
};
